import { render, staticRenderFns } from "./ArticleAdd.vue?vue&type=template&id=d84d39e4&scoped=true&"
import script from "./ArticleAdd.vue?vue&type=script&lang=ts&"
export * from "./ArticleAdd.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleAdd.vue?vue&type=style&index=0&id=d84d39e4&lang=scss&scoped=true&"
import style1 from "./ArticleAdd.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84d39e4",
  null
  
)

export default component.exports